export function hideFormBuilderOptionValues() {
  $('.option-value').hide(); // hide field "Option Value"
  $('.option-id').hide(); // hide field "Option Id"

  // for new options, run check again
  $('.add-opt').off('click').on('click', () => {
    setTimeout(() => hideFormBuilderOptionValues(), 50); // add small timeout to wait for render
  });
}

